import React, { useState, Component, Suspense } from "react";
import styled from "styled-components";
import Axios from "axios";
import { wrapperEndPoint } from "../../../Utils/Api";

const STPRbibbonWrapper = styled.div`
  position: absolute;
  width: 100%;

  background: #fff;
  bottom: 84px;
  height: 50px;

  .inactive {
    pointer-events: none;
    opacity: 0.6;
  }
  // .bottomAlign{
  //   bottom: 35px;
  // }
`;
const STPRbibbonSlider = styled.div`
  width: 86%;
  margin: auto;
  position: relative;

  height: 50px;
  // background:red;
  white-space: nowrap;
  padding: 7px 0;
  overflow: hidden;
  display: flex;
  justify-content: centre;

  // flex-wrap: nowrap;
  // flex-direction: row;

  // display: flex;
  // flex-wrap: wrap;
  // flex: 20%;
`;
const Card = styled.div`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background: #ffffff;
  width: 150px;
  height: 36px;
  margin: 0 11px;
  // margin-right: 24px;
  border-radius: 5px;
  cursor: pointer;
  // transition: transform 0.2s;
  // padding: 8.5px 20px;
  border: 1px solid #003e8d;
  color: #003e8d;
  box-sizing: border-box;
  font-size: 12px;
  white-space: normal;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.024);

  .stpRibbonTitle {
    // background:blue;
    margin: auto;
    text-align: center;
    margin-top: 17px;
    line-height: 13px;
    transform: translateY(-50%);
  }

  :hover {
    background: #003e8d;
    color: #ffffff;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.024);
  }
`;
const BtnR = styled.div`
  position: absolute;
  width: 20px;
  height: 28px;
  right: 0px;
  top: 10px;
  border-radius: 16px 0 0 16px;
  border: 1px solid #b72c2c;
  border-right: 1px solid #ffffff;
  background: white;
  color: #b72c2c;
  cursor: pointer;
  padding-left: 9px;
  padding-top: 3.5px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  //z-index: 100;
  //transform:translateX(-50%);
`;
const BtnL = styled.div`
  position: absolute;
  width: 20px;
  height: 28px;
  left: 0px;
  top: 10px;
  border-radius: 0 16px 16px 0;
  border: 1px solid #b72c2c;
  border-left: 1px solid #ffffff;
  background: white;
  color: #b72c2c;
  cursor: pointer;
  padding-left: 2.5px;
  padding-top: 3.5px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  //z-index: 100;
  //transform:translateX(-50%);
`;

class STPRibbon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCard: 1,
      position: 0,
      transitionTime: 0,
      cardStyle: {
        transform: "translateX(0px)",
        transition: "transform 0.5s",
        // transition: '0.2s ease',
      },
      width: 172, //card width + margin left + right = 150 + 22
      stpRibbonData: [],
    };
    this.placeholderInterval = null;
  }

  componentDidMount() {
    Axios.get(wrapperEndPoint.STPRibbonURL, { withCredentials: false })
      .then((response) => {
        this.setState({ stpRibbonData: response.data });
        //  console.log(this.state.stpRibbonData);
        // console.log(response);
        // this.startAutoSlide();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // componentWillUnmount() {
  //   this.stopAutoSlide();
  // }

  // stopAutoSlide = () => {
  //   if (this.placeholderInterval) {
  //     clearInterval(this.placeholderInterval);
  //     this.placeholderInterval = null;
  //   }
  // };

  // restartAutoSlide = () => {
  //   this.startAutoSlide();
  // };

  // startAutoSlide = () => {
  //   if (this.placeholderInterval) {
  //     clearInterval(this.placeholderInterval); // Clear any existing interval
  //   }

  //   this.placeholderInterval = setInterval(() => {
  //     console.log(this.state.currentCard);

  //     if (this.state.currentCard < this.state.stpRibbonData.length - 1) {
  //       this.autoSlide(true, "next");
  //     } else {
  //       clearInterval(this.placeholderInterval);
  //       this.setCard(1, 0, 0);
  //       this.restartAutoSlide();
  //       // this.startReverseSlide(); // Stop when reaching the last item and start from reverse slide
  //     }
  //   }, 2500);
  // };

  // startReverseSlide = () => {
  //   if (this.placeholderInterval) {
  //     clearInterval(this.placeholderInterval); // Clear any existing interval
  //   }

  //   this.placeholderInterval = setInterval(() => {
  //     console.log(this.state.currentCard);

  //     if (
  //       this.state.currentCard >
  //       this.state.stpRibbonData.length - this.state.currentCard
  //     ) {
  //       this.autoSlide(true, "prev");
  //     } else {
  //       clearInterval(this.placeholderInterval);
  //       this.startAutoSlide(); // Stop when reaching the first item and start from reverse slide
  //     }
  //   }, 3000);
  // };

  // autoSlide(isSlideAllowed, slidePos) {
  //   console.log(slidePos);
  //   if (
  //     isSlideAllowed &&
  //     slidePos &&
  //     this.state.stpRibbonData &&
  //     this.state.stpRibbonData.length > 1
  //   ) {
  //     this.handleClick(slidePos);
  //   }
  // }

  handleClick(direction) {
    // get the card's margin-right
    // let margin = window.getComputedStyle(document.getElementById("card1")).marginRight;
    // margin = JSON.parse(margin.replace(/px/i, ''));

    const cardWidth = this.state.width; // the card's width
    //const cardMargin = margin; // the card's margin
    const cardNumber = this.state.stpRibbonData.length; // the number of cards//here**
    let currentCard = this.state.currentCard; // the index of the current card
    let position = this.state.position; // the position of the cards
    let transitionTime = this.state.transitionTime;

    // slide cards
    if (direction === "next") {
      position -= cardWidth;
      //  console.log(position)

      transitionTime = 0;
      // position = - (cardWidth);//- (cardWidth+cardMargin);
      // let activeCard = document.getElementById('card' + currentCard)
      // let lastCard = document.getElementById("slider").lastChild;
      // lastCard.parentNode.insertBefore(activeCard, lastCard.nextSibling);
      this.setCard(currentCard, position, transitionTime);
      if (currentCard == cardNumber) {
        currentCard = 1;
      } else {
        currentCard++;
      }
    } else if (direction === "prev") {
      position += cardWidth;

      transitionTime = 0;
      // position = -(cardWidth); //-(cardWidth+cardMargin);
      // let activeCard = document.getElementById('card' + currentCard)
      // let lastCard = document.getElementById("slider").lastChild;
      // activeCard.before(lastCard);
      this.setCard(currentCard, position, transitionTime);

      if (currentCard == 1) {
        currentCard = cardNumber;
      } else {
        currentCard--;
      }
    }

    //    console.log(currentCard)

    this.setCard(currentCard, position, transitionTime);
  }

  setCard(currentCard, position, transitionTime) {
    this.setState({
      currentCard: currentCard,
      position: position,
      transitionTime: transitionTime,
      cardStyle: {
        // transform: 'translateX(0px)',
        // transition: 'transform 0.9s'

        transform: `translateX(${position}px)`,
        transition: "transform 0.5s",
        // transition: `${transitionTime}s ease`,
      },
    });
  }

  render() {
    return (
      <STPRbibbonWrapper
        style={{ bottom: this.props.isInputDisabled ? "35px" : "84px" }}
      >
        <BtnL
          className={`${this.state.currentCard == 1 ? "inactive" : ""}`}
          id="btnLeft"
          onClick={() => {
            this.handleClick("prev");
            // this.stopAutoSlide();
            // setTimeout(() => {
            //   this.restartAutoSlide();
            // }, 2000);
          }}
        >
          &lt;
        </BtnL>
        <BtnR
          className={`${
            this.state.currentCard == this.state.stpRibbonData.length - 1
              ? "inactive"
              : ""
          }`}
          id="btnRight"
          onClick={() => {
            this.handleClick("next");
            // this.stopAutoSlide();
            // setTimeout(() => {
            //   this.restartAutoSlide();
            // }, 2000);
          }}
        >
          &gt;
        </BtnR>

        <STPRbibbonSlider>
          <STPRbibbonCards
            cardStyle={this.state.cardStyle}
            addServerResponse={this.props.addServerResponse}
            handleJustUIPrintCall={this.props.handleJustUIPrintCall}
            chatMessages={this.props.chatMessages}
            stpRibbonData={this.state.stpRibbonData}
          />
        </STPRbibbonSlider>
      </STPRbibbonWrapper>
    );
  }
}

/* *************************************STPRbibbonCards COMP********************************************************* */

class STPRbibbonCards extends Component {
  handleSTPRibbonClick(selectedItem, i) {
    // console.log(selectedItem,i,this.props.stpRibbonData[i].submenu);
    let submenuArray = this.props.stpRibbonData[i].submenu;

    if (submenuArray.length > 1) {
      let subResponse =
        "<div>Please select one of the options to continue or type your query below.</div>" +
        `<div>${submenuArray
          .map((item, j) => {
            return (
              '<div class="action-elem" onClick="javascript:autosubmit(\'' +
              item.actionText +
              "','" +
              j +
              "')\">" +
              item.displayText +
              "</div>"
            );
          })
          .join("")}</div>`;

      setTimeout(() => {
        this.props.addServerResponse({ answer: subResponse });
      }, 200);

      this.props.handleJustUIPrintCall(selectedItem);
    } else if (submenuArray.length == 1) {
      let inputString =
        submenuArray[0].actionText + "<split>" + submenuArray[0].actionText;
      window["autosubmit"](inputString);
    }
  }

  render() {
    return (
      <div id="slider" style={this.props.cardStyle}>
        {this.props.stpRibbonData.map((card, i) => {
          return (
            <Card
              id={card.id}
              key={i}
              onClick={() => this.handleSTPRibbonClick(card.category, i)}
            >
              <div className="stpRibbonTitle">{card.category}</div>
            </Card>
          );
        })}
      </div>
    );
  }
}

export default STPRibbon;
